import React, { Fragment } from 'react'
import { makeStyles, CircularProgress, Typography } from '@material-ui/core'
import { EditIcon } from '../../../Assets/Images/icons/editIcon'
import { roleLabel } from '../../UserManagement/UsersListTable'
import { styles } from './styles'
import { ROLE_CLIENT, ROLE_CLIENT_ADMIN } from '../../../shared/constants'
import classNames from 'classnames'
import { getReadableRoleByUser } from '../../UserManagement/UserDetails/utils'

const useStyles = makeStyles(() => styles)

export const ProfileInfo = ({ user, setEdit, edit }) => {
  const classes = useStyles()
  const loading = !Object.values(user).length

  return loading ? (
    <div className={classes.loadingContainer}>
      <CircularProgress />
    </div>
  ) : (
    <Fragment>
      <div
        className={classNames(
          classes.infoContainer,
          'makeStyles-infoContainer',
        )}
      >
        <div
          className={classNames(classes.imageColumn, 'makeStyles-imageColumn')}
        >
          <img
            className={classNames(classes.image, 'makeStyles-image')}
            src={user.profilePicture}
            alt="profile"
            cypress_id={'userProfileAvatar'}
          />
        </div>
        <div className={classes.info}>
          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography className={classes.userName} cypress_id={'userName'}>
                {user.firstName} {user.lastName}
              </Typography>
              <Typography cypress_id={'userRole'}>
                {roleLabel[getReadableRoleByUser(user)]}
              </Typography>
            </div>
          </div>

          <div className={classNames(classes.row, 'makeStyles-row')}>
            {[ROLE_CLIENT_ADMIN, ROLE_CLIENT].includes(user.role) ? null : (
              <div
                className={classNames(classes.infoItem, 'makeStyles-infoItem')}
              >
                <Typography className={classes.infoItemTitle}>
                  Country
                </Typography>
                <Typography>{user.countryName}</Typography>
              </div>
            )}

            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography
                className={classes.infoItemTitle}
                cypress_id={'companyFieldTitle'}
              >
                Company
              </Typography>
              <Typography cypress_id={'companyName'}>
                {(user.client && user.client.name) || '-'}
              </Typography>
            </div>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            />
          </div>

          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography
                className={classes.infoItemTitle}
                cypress_id={'emailAddressFieldTitle'}
              >
                Email address
              </Typography>
              <Typography cypress_id={'emailAddress'}>{user.email}</Typography>
            </div>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography
                className={classes.infoItemTitle}
                cypress_id={'businessPhoneNumberFieldTitle'}
              >
                Business phone number
              </Typography>
              <Typography cypress_id={'businessPhoneNumber'}>
                {user.mobilePhone}
              </Typography>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.buttonsContainer}>
        <button
          className={classes.profileButton}
          onClick={() => {
            setEdit(!edit)
          }}
          variant="outlined"
          cypress_id={'profileBtn'}
        >
          <EditIcon />
          <span className={classes.editButtonLabel}>Edit</span>
        </button>
      </div>
    </Fragment>
  )
}
